import React, { ReactElement } from "react";
import KeywordList from "../../components/Keywords";
import Layout from "../../components/layout";

const KeywordPage = (): ReactElement => {
  return (
    <Layout>
      <KeywordList />
    </Layout>
  );
};

export default KeywordPage;
